import { observer } from 'mobx-react-lite'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { ArrowRight, Search } from 'react-bootstrap-icons'
import { CampaignContext } from '../../../../../contexts/CampaignContext'

const SEARCH_DEBOUNCE_MS = 500

export default observer(function FilenameSearch() {
  const { documentSearch } = useContext(CampaignContext)
  const [filename, setFilename] = useState(documentSearch.file)
  const searchTimeout = useRef(null)

  useEffect(() => {
    return () => {
      if(searchTimeout.current) clearTimeout(searchTimeout.current)
    }
  }, [])

  const searchByFilename = ({ target: { value }}) => {
    setFilename(value)
    if(searchTimeout.current) clearTimeout(searchTimeout.current)

    searchTimeout.current = setTimeout(() => {
      documentSearch.file = value.trim()
    }, SEARCH_DEBOUNCE_MS)
  }

  return (
    <div className="flex items-center justify-between border-1 dark:border-rb-dark-mode-lighter rounded-xl bg-gray-100 dark:bg-rb-dark-mode-lighter p-1 w-1/2 max-w-2xl">
      <div className="rounded-xl p-3 bg-white dark:bg-rb-dark-mode dark:text-white"><Search /></div>
      <input className="border-0 focus:ring-transparent focus:ring-offset-transparent bg-gray-100 dark:bg-rb-dark-mode-lighter dark:text-white dark:placeholder-gray-400 w-full" placeholder="Search files" type="text" value={filename} onChange={searchByFilename} />
      <div className="bg-rb-green rounded-xl p-3 dark:text-white"><ArrowRight /></div>
    </div>
  )
})